import {useEffect, useState} from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import {useTranslation} from 'react-i18next'

import {openAlert} from '../../../../../../_metronic/elements/NotificationAlert'
import {useErrorHandler} from '../../../../../../_metronic/helpers/ErrorHandler'
import {LoadingCard} from '../../../../../../_metronic/elements/Loading'
import {useViewFieldContext} from '../ViewFieldContext'
import {useSearchContext} from '../../../Toolbar/SearchContext'
import {useMapLayersV2} from '../../../Map/MapLayersV2Context'
import {LandDraftBuilder} from '../../LandDraftBuilder'
import * as LandService from '../../services/LandService'

const CreateLand = () => {
  const [loading, setLoading] = useState(false)
  const {t} = useTranslation()
  const {errorHandler} = useErrorHandler()
  const {field_id} = useParams()
  const {field, load, lands, loading: loadingField, setFieldId} = useViewFieldContext()
  const searchContext = useSearchContext()
  const mapLayers = useMapLayersV2()
  const navigate = useNavigate()

  useEffect(() => {
    document.getElementById('kt_content_container')?.scroll({top: 0, behavior: 'smooth'})
  }, [])

  useEffect(() => {
    setFieldId(field_id)
  }, [field_id, setFieldId])

  if (loadingField || field == null) {
    return <LoadingCard className='field-view-container' />
  }

  const save = async ({pendingLands}) => {
    setLoading(true)

    const res = await errorHandler(
      LandService.create(field_id, {
        lands: pendingLands,
      })
    )

    if (!res?.ok) {
      setLoading(false)
      return
    }

    setLoading(false)
    navigate(`/gis/field/view/${field_id}`)
    openAlert('success', t('lands:create.success.title'), t('lands:create.success.message'))
    mapLayers.reloadSource()
    searchContext.load()
    load()
  }

  return (
    <div className='d-flex flex-column flex-row-auto field-view-flex-container field-view-create-land-flow'>
      <div className='d-flex flex-column-auto displayable mb-4'>
        <LandDraftBuilder
          title={t('fields:buttons.add_lands')}
          baseName={field.name}
          startIndex={lands.length}
          submitLabel={t('lands:create.buttons.create')}
          loading={loading}
          onCancel={() => navigate(`/gis/field/view/${field_id}`)}
          onSubmit={save}
        />
      </div>
    </div>
  )
}

export default CreateLand
